export const PROJECT_LEVEL_ALERTS_PREFIX = 'pla:'
